import { EligibleIncentive } from "../../services/MyBizShell/mybizShellAPI.types";

export const isProgramActive = (
  eligibleIncentives: EligibleIncentive[] = [],
  awardCode: number,
  featureFlag = true,
) => {
  return (
    featureFlag === true &&
    eligibleIncentives.some(({ awardNumber, programActive }) => awardNumber === awardCode && programActive === true)
  );
};

export const isProgramActiveBulkCheck = (eligibleIncentives: EligibleIncentive[] = [], awardCodes: number[]) => {
  return eligibleIncentives.some(
    ({ awardNumber, programActive }) => awardCodes.includes(awardNumber) && programActive === true,
  );
};

export const isProgramComingSoonBulkCheck = (eligibleIncentives: EligibleIncentive[] = [], awardCodes: number[]) => {
  return eligibleIncentives.some(
    ({ awardNumber, programActive, comingSoon }) => awardCodes.includes(awardNumber) && comingSoon === true,
  );
};
